import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from '@fluentui/react-components';
import React, { useContext, useEffect } from 'react';
import { Job } from '../library/CosmeWidgetAPIClient';
import { CWClientContext } from '../App';

function JobPage() {
    const [jobs, setJobs] = React.useState<Job[]>([]);
    const cwClient = useContext(CWClientContext);


    useEffect(() => {
        cwClient.jobs().then((jobs) => {
            console.log("job    s", jobs);
            setJobs(jobs);
        });
    }, []);


    return (
        <>
            <h2>JobPage</h2>
            <Table>
                <TableHeader>
                    <TableHeaderCell>
                        ジョブ作成日時
                    </TableHeaderCell>
                    <TableHeaderCell>
                        ジョブ種別
                    </TableHeaderCell>
                    <TableHeaderCell>
                        作成者
                    </TableHeaderCell>
                    <TableHeaderCell>
                        ステータス
                    </TableHeaderCell>
                </TableHeader>
                <TableBody>
                    {jobs.map((job) => {
                        return (
                            <TableRow>
                                <TableCell>
                                    {job.createdAt?.toLocaleString()}
                                </TableCell>
                                <TableCell>
                                    {job.type}
                                </TableCell>
                                <TableCell>
                                    {job.createBy}
                                </TableCell>
                                <TableCell>
                                    {job.status}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </>
    );
}

export default JobPage;